import { Col, HeadingText, Link, Row } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import classNames from 'classnames'
import React, { Suspense, useEffect } from 'react'
import { componentNames, fptiTypes } from '../../utils/analytics/fpti-constants'
import { HERO_MODULE_DATA } from '../../utils/prop-type-shape'
import ShimmerLoader from '../loaders/shimmerLoader'
// Hooks
import { useHelper } from '../../hooks/useHelper'
import useTracking from '../../hooks/useTracking'

// styles
import './hero-module.less'

const SearchBar = React.lazy(() =>
  import('../search-bar' /* webpackPrefetch: true */),
)

// Hero Module Component - The top section with search component
function HeroModule() {
  const { isLoggedIn, getDisplayName, generateLinkWithCoBrand, getPageName } =
    useHelper()
  const { trackActivity } = useTracking()

  useEffect(() => {
    trackActivity({
      name: componentNames.HERO_MODULE,
      type: fptiTypes.SUCCESS,
    })
  }, [trackActivity])

  const isHomeGreetingEnabled = getPageName() === 'home'
  const renderUserGreering = () => {
    return (
      isHomeGreetingEnabled &&
      isLoggedIn() && (
        <HeadingText
          data-testid="hc-hero-module-user-greeting"
          as="h1"
          size="lg"
        >
          <Message id="app.help.user.greeting" name={getDisplayName()} />
        </HeadingText>
      )
    )
  }

  return (
    <Row
      className={classNames('hero-module', {
        'hero-module--default': !isHomeGreetingEnabled,
        'hero-module--home-page': !!isHomeGreetingEnabled,
      })}
      data-testid="hc-hero-module-section"
    >
      <Col md={6}>
        <Link
          className="hero-module__hc-link"
          href={generateLinkWithCoBrand('/smarthelp/home')}
          data-testid="hc-hero-module-helpcenter-link"
        >
          <Message id="app.helpcenter.title" />
        </Link>

        {renderUserGreering()}
        <Suspense fallback={<ShimmerLoader />}>
          <SearchBar />
        </Suspense>
      </Col>
    </Row>
  )
}

HeroModule.propTypes = HERO_MODULE_DATA

export default HeroModule
